import React from "react";
import moment from "moment";
import BFL1TableRows from "./BFL1TableRows";
import {
	EBFL1RecordCode,
	EBFL1RecordState,
	TBFL1BackendRecord,
} from "../../../../redux/app/bfl-1/@types";
import BFL1A1Preview from "./previews/BFL1A1Preview";
import BFL1B1Preview from "./previews/BFL1B1Preview";
import BFL1C1Preview from "./previews/BFL1C1Preview";
import BFL1D1Preview from "./previews/BFL1D1Preview";
import BFL1D2Preview from "./previews/BFL1D2Preview";
type OwnProps = {
	bfl1Record: TBFL1BackendRecord;
};
type BFL1PreviewerProps = OwnProps;
function BFL1Previewer(props: BFL1PreviewerProps) {
	const { bfl1Record: record } = props;
	const isStrikedOff = record.state === EBFL1RecordState.STRIKED_OFF;
	const isEditOfApprovedRecord = !!record.dateOfApprovedRecordEdit;

	function renderMain() {
		if (isEditOfApprovedRecord) return renderEditedApprovedRecord();
		return renderRecord(record, isStrikedOff);
	}

	function renderEditedApprovedRecord() {
		if (!record.dateOfApprovedRecordEdit) return null;
		return (
			<>
				{renderEditCorrectionLine()}
				{renderRecord(
					{ ...record, selectedDate: record.dateOfApprovedRecordEdit },
					isStrikedOff
				)}
				{renderStruckOffVersionOfEdit()}
			</>
		);
	}
	function renderEditCorrectionLine() {
		if (!record.dateOfApprovedRecordEdit) return null;
		const formattedEditDate = moment(record.selectedDate, "YYYY-MM-DD").format(
			"DD-MMM-YYYY"
		);

		return (
			<BFL1TableRows
				record={record}
				tableRows={[
					[
						formattedEditDate,
						"D",
						"-",
						"ENTRY PERTAINING TO AN EARLIER INCORRECT OPERATIONAL ENTRY",
					],
				]}
			/>
		);
	}
	function renderStruckOffVersionOfEdit() {
		if (!record.editVersions) return null;
		const oldVersionOfRecord = {
			...record.editVersions[0],
			state: EBFL1RecordState.STRIKED_OFF,
		};
		return <BFL1Previewer bfl1Record={oldVersionOfRecord} />;
	}

	function renderRecord(
		recordToRender: TBFL1BackendRecord,
		isStrikedOff: boolean = false
	) {
		switch (recordToRender.recordCode) {
			case EBFL1RecordCode.BFL1A1:
				return (
					<BFL1A1Preview
						bfl1Record={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);

			case EBFL1RecordCode.BFL1B1:
				return (
					<BFL1B1Preview
						bfl1Record={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);

			case EBFL1RecordCode.BFL1C1:
				return (
					<BFL1C1Preview
						bfl1Record={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);

			case EBFL1RecordCode.BFL1D1:
				return (
					<BFL1D1Preview
						bfl1Record={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);

			case EBFL1RecordCode.BFL1D2:
				return (
					<BFL1D2Preview
						bfl1Record={recordToRender}
						isStrikedOff={isStrikedOff}
					/>
				);
			default:
				return null;
		}
	}

	return renderMain();
}

export default BFL1Previewer;
